var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-1"},[_c('v-col',{staticClass:"py-0"},[_c('DatetimePicker',_vm._b({staticStyle:{"width":"100%"},attrs:{"textFieldProps":{
        label: _vm.lgLabel
      },"disabled":_vm.formDisabled,"auto-grow":"","dense":"","outlined":""},on:{"input":v => _vm.handleUpdate({ value: v })},model:{value:(_vm.value.date),callback:function ($$v) {_vm.$set(_vm.value, "date", $$v)},expression:"value.date"}},'DatetimePicker',{ ..._vm.$attrs },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }